import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"value":_vm.value,"label":_vm.data && _vm.data.NAME ? _vm.data.NAME : 'Select an option',"items":_vm.dropdownOptions,"item-value":"value","item-text":"text","dense":""},on:{"change":_vm.emitSelection},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"color-circle",style:({ backgroundColor: '#' + item.color })}),_vm._v("\n            "+_vm._s(item.text)+"\n        ")])]}},{key:"item",fn:function(ref){
var item = ref.item;
var on = ref.on;
var attrs = ref.attrs;
return [_c(VListItem,_vm._g(_vm._b({},'v-list-item',attrs,false),on),[_c(VListItemContent,{staticClass:"d-flex align-center"},[_c('span',{style:({
          backgroundColor: '#' + item.color,
          padding: '3px 6px',
          color: '#fff',
          borderRadius: '4px'
        })},[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }